import BackButtonToolbar from "features/BackButtonToolbar";
import { Edit } from "react-admin";

import SaveForm from "./SaveForm";

const EditScholarshipBudget = () => {
  // Edit is reachable only for MGU (university-wide budgets); MU budgets are per-faculty and have no edit action.
  const transform = ({ fiscalYear, amount }) => ({ fiscalYear, amount, isUniversityWide: true });

  return (
    <Edit
      title="Редакция на бюджет за стипендия"
      actions={<BackButtonToolbar />}
      mutationMode="pessimistic"
      transform={transform}
    >
      <SaveForm />
    </Edit>
  );
};

export default EditScholarshipBudget;
